<template>
    <div>
        <v-alert v-model="showMaintenanceBanner" type="info" text outlined>
            <div class="d-flex">
                <div>
                    <p>
                        <strong>V sobotu 25. 4. 2026 a neděli 26. 4. 2026 od 13:00 do 18:00</strong>
                        bude probíhat aktualizace serverů. Během této doby může docházet ke krátkým
                        výpadkům portálu, které mohou způsobit ztrátu rozpracované práce (neuložené
                        údaje ve formulářích).
                    </p>
                    <p>
                        Pokud je to možné, doporučujeme zadávání údajů naplánovat mimo termín údržby.
                    </p>
                    <p>Děkujeme za pochopení.</p>
                </div>
                <div class="text-right">
                    <v-btn
                        icon
                        color="primary"
                        @click="handleClickMaitenanceBanner"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
        </v-alert>

        <div v-if="showSPBanner" class="sp-16-banner">
            <div class="text-right">
                <v-btn icon small @click="handleClickBanner">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>

            <template v-if="userRole === 'doctor'">
                <div class="d-flex align-center mb-2">
                    <v-icon color="info" class="mr-2">mdi-information-outline</v-icon>
                    <h3>Od 20. 4. 2026</h3>
                </div>
                <p>
                    se mění podmínky pro výkon funkce odborného garanta, blíže
                    ust. § 6a Stavovském předpisu č. 16.
                </p>
                <v-divider class="mb-4"/>
                <div class="d-flex align-center mb-2">
                    <v-icon color="info" class="mr-2">mdi-information-outline</v-icon>
                    <h3>Od 1. 1. 2025</h3>
                </div>
                <p>
                    dochází ke změně ve Stavovském předpisu č.16, který mění
                    podmínky pro získání diplomu celoživotního vzdělávání.
                </p>
                <div
                    class="font-weight-bold mb-2"
                    style="text-decoration: underline"
                >
                    Zde je výpis nejdůležitějších změn pro lékaře:
                </div>
                <ul class="mb-4">
                    <li>
                        Za <strong>stáže</strong> lze uznat pro získání diplomu
                        celoživotního vzdělávání nejvíce
                        <strong>75 kreditů</strong>.
                    </li>
                    <li>
                        Za <strong>e-learningové kurzy</strong> lze uznat pro
                        získání diplomu celoživotního vzdělávání nejvíce
                        <strong>75 kreditů</strong>.
                    </li>
                    <li>
                        Lékař může pro účely započítání kreditů v systému
                        celoživotního vzdělávání absolvovat
                        <strong>maximálně 2 e-learningové kurzy denně</strong>.
                    </li>
                    <li>
                        Platnost nového diplomu celoživotního vzdělávání může
                        být nastavena na následující den po posledním dnu
                        platnosti předchozího diplomu (<strong
                            >platnosti diplomů se nesmí překrývat</strong
                        >).
                    </li>
                </ul>
                <p>
                    Veškeré změny naleznete v novém znění Stavovského předpisu
                    č. 16
                    <a :href="sp16Url" target="_blank">ZDE</a>
                </p>
                <p>
                    V případě dotazů se obracejte na oddělení vzdělávání ČLK,
                    e-mail:
                    <a href="mailto:vzdelavani3@clkcr.cz"
                        >vzdelavani3@clkcr.cz</a
                    >, tel.: +420 234 760 703.
                </p>
            </template>

            <template v-else-if="userRole === 'registrar'">
                <div class="d-flex align-center mb-2">
                    <v-icon color="info" class="mr-2"
                        >
mdi-information-outline
</v-icon
                    >
                    <h3>Od 20. 4. 2026</h3>
                </div>
                <p>
                    se mění podmínky pro výkon funkce odborného garanta, blíže
                    ust. § 6a Stavovském předpisu č. 16.
                </p>
                <v-divider class="mb-4"/>
                <div class="d-flex align-center mb-2">
                    <v-icon color="info" class="mr-2"
                        >
mdi-information-outline
</v-icon
                    >
                    <h3>Od 1. 1. 2025</h3>
                </div>
                <p>dochází ke změně ve Stavovském předpisu č.16.</p>

                <div
                    class="font-weight-bold mb-2"
                    style="text-decoration: underline"
                >
                    Nejdůležitější změny pro poskytovatele:
                </div>
                <ul class="mb-4">
                    <li>
                        povinnosti nahrávat prezenční listinu absolventů vč.
                        data absolvování,
                        <strong>do 10 dnů po ukončení</strong> vzdělávací akce
                        do portálu vzdělávacích akcí, v případě
                        <strong>e-learningu minimálně 1x měsíčně.</strong>
                    </li>
                    <li>
                        pro získání akreditace e-learningového kurzu bude
                        zapotřebí
                        <strong
                            >délka 2 vyučovacích hodin (90 minut) a 15 otázek v
                            rámci autodidaktického testu</strong
                        >.
                    </li>
                    <li>
                        Se změnou Stavovského předpisu dochází i ke změně výše
                        akreditačních poplatků, viz.
                        <strong>Příloha č.1 §4</strong>
                    </li>
                </ul>
                <p>
                    Veškeré změny naleznete v novém znění Stavovského předpisu
                    č. 16
                    <a :href="sp16Url" target="_blank">ZDE</a>
                </p>
            </template>
        </div>

        <v-dialog v-model="showMaintenanceDialog" max-width="500" persistent>
            <v-card class="pa-8">
                <p>
                    <strong>V sobotu 25. 4. 2026 a neděli 26. 4. 2026 od 13:00 do 18:00</strong>
                    bude probíhat aktualizace serverů. Během této doby může docházet ke krátkým
                    výpadkům portálu, které mohou způsobit ztrátu rozpracované práce (neuložené
                    údaje ve formulářích).
                </p>
                <p>
                    Pokud je to možné, doporučujeme zadávání údajů naplánovat mimo termín údržby.
                </p>
                <p>Děkujeme za pochopení.</p>
                <v-btn
                    class="mt-8"
                    color="primary"
                    block
                    @click="handledClickDialog"
                >
                    Rozumím
                </v-btn>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { getUserRole } from '@/utils/localStorageUtils';

const SP_BANNER_KEY = 'showSPBanner_v2';

export default {
    data() {
        return {
            showSPBanner: false,
            userRole: null,
            showMaintenanceDialog: false,
            showMaintenanceBanner: false,
            sp16Url:
                'https://soubory-vzdelavani-l.b-cdn.net/SP%20c%CC%8C.%2016%20-%20Syste%CC%81m%20celoz%CC%8Civotni%CC%81ho%20vzde%CC%8Cla%CC%81va%CC%81ni%CC%81%20le%CC%81kar%CC%8Cu%CC%8A%20C%CC%8CLK%20-%20novela%2C%20u%CC%81c%CC%8Cinnost%2020.4.2026.pdf'
        };
    },

    mounted() {
        this.userRole = getUserRole();

        this.showSPBanner = !localStorage.getItem(SP_BANNER_KEY);

        const today = new Date();
        const maintenanceCutoff = new Date('2026-04-27');

        if (today >= maintenanceCutoff) {
            this.showMaintenanceDialog = false;
            this.showMaintenanceBanner = false;
            return;
        }

        this.showMaintenanceDialog = !localStorage.getItem(
            'showMaintenanceDialog_v2'
        );

        this.showMaintenanceBanner = !localStorage.getItem(
            'showMaintenanceBanner_v2'
        );
    },

    methods: {
        handledClickDialog() {
            localStorage.setItem('showMaintenanceDialog_v2', 'false');
            this.showMaintenanceDialog = false;
        },
        handleClickBanner() {
            localStorage.setItem(SP_BANNER_KEY, 'false');
            this.showSPBanner = false;
        },
        handleClickMaitenanceBanner() {
            localStorage.setItem('showMaintenanceBanner_v2', 'false');
            this.showMaintenanceBanner = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.sp-16-banner {
    background-color: #f0f9fe;
    padding: 1rem;
    border: 1px solid red;
    border-radius: 1rem;
    margin-bottom: 2rem;
    font-size: 1rem;
}

.v-alert {
    border-radius: 1rem !important;
}
</style>
